import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { paginationDefault } from 'constants/pagination';
import { TResponsePagination } from 'libs/axios';
import { TOptionsQuery, TPagination } from 'types/common';
import { TControlInitDetail } from 'types/controlInit';
import { TUserDetail } from 'types/groups';

type TShowModal = 'groups' | 'delete' | '';
export type TDataFileUpload = { fname?: string; originalName?: string };

export type TControlInitState = {
  loading: boolean;
  error: boolean;
  showModal: TShowModal;
  message: string;
  controlInit: Array<TControlInitDetail>;
  controlInitDetail: TControlInitDetail;
  pagination: TPagination;
  dataFileUpload: TDataFileUpload;
};

const initialState: TControlInitState = {
  loading: false,
  error: false,
  showModal: '',
  message: '',
  controlInit: [],
  controlInitDetail: {},
  pagination: paginationDefault(),
  dataFileUpload: {},
};

const _module = createSlice({
  name: 'controlInit',
  initialState,
  reducers: {
    loading(state: TControlInitState) {
      return {
        ...state,
        loading: true,
      };
    },
    stopLoading(state) {
      return {
        ...state,
        loading: false,
      };
    },
    setError(state: TControlInitState, action: PayloadAction<boolean>) {
      return {
        ...state,
        error: action.payload,
      };
    },
    setModal: (state: TControlInitState, action: PayloadAction<TShowModal>) => ({
      ...state,
      showModal: action.payload,
    }),

    createSuccess(state, action: PayloadAction<TShowModal>) {
      return {
        ...state,
        showModalNoti: action.payload,
      };
    },
    clearSuccess(state) {
      return {
        ...state,
        showModalNoti: '',
      };
    },
    getListControlInit: (state: TControlInitState, action: PayloadAction<TResponsePagination<TControlInitDetail>>) => {
      const { results, ...pagination } = action.payload;
      return {
        ...state,
        controlInit: results,
        pagination,
      };
    },
    removeControlInit: (state: TControlInitState, action: PayloadAction<number>) => {
      const newListControlInit = state.controlInit.filter((g: TControlInitDetail) => g.id !== action.payload);
      return {
        ...state,
        controlInit: newListControlInit,
      };
    },
    saveControlInitDetail: (state: TControlInitState, action: PayloadAction<TControlInitDetail>) => ({
      ...state,
      controlInitDetail: action.payload,
    }),
    saveListControlInit: (state: TControlInitState, action: PayloadAction<TControlInitDetail>) => ({
      ...state,
      controlInit: [...state.controlInit, action.payload],
    }),
    setDataFileUpload: (state: TControlInitState, action: PayloadAction<TDataFileUpload>) => ({
      ...state,
      dataFileUpload: action.payload,
    }),
  },
});

export const controlInitModule = _module;
